import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { MobilyForm as mobilyForm } from "mobilyform/lib"
import { withTranslation } from "react-i18next";
import { formModal } from "./data"
import { COMPONENTS } from "Constants"
import { complainsApi } from "api"
import { encrypt } from "core/utils/encrypt"
import { error, success } from "core/utils/toast"
import { UseSharedData } from "contexts";

const win: any = window;
const lang = win['lang']
const rtl = !(lang === "en")
const lang_prefix = (rtl ? "Ar" : "En")

const MobilyForm: any = mobilyForm




const ComplaintInfo = () => {
  const { t } = useTranslation();
  const [collapsedState, setCollapsedState] = useState<boolean>(false)
  const [loading, setLoading] = useState<boolean>(false)
  const { Reducer, complaintsInfo } = UseSharedData();


  useEffect(() => {
    console.log("complaintsInfo", complaintsInfo)
    // complainsApi.getIDTypes().then((res: any) => {
    //   setIdTypes(res.typesList)
    //   setLoading(false)
    // }).catch(e => {
    //   console.log(e)
    //   setLoading(false)
    // })
  }, [])


  return (
    <div className="custom-rich-text">
      <MobilyForm
        formRef={React.createRef()}
        formModal={formModal(() => { },
          collapsedState,
          t,
          () => setCollapsedState(!collapsedState),
          complaintsInfo)}
        loading={loading}
      ></MobilyForm>
    </div>
  );
}


export default ComplaintInfo